/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Owner_SelfInputs */



/**
* | output |
* | --- |
* | "That's your own id: you already own this server." |
*
* @param {Tenant_Owner_SelfInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_owner_self = /** @type {((inputs?: Tenant_Owner_SelfInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Owner_SelfInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это ваш собственный ID — вы уже владеете этим сервером.")
	return /** @type {LocalizedString} */ ("That's your own id: you already own this server.")
});